import { FloatingButtonSimple } from "webapp/ui/views/floating-button/floating-button";
import { styled } from "../../../styled-components";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;

    flex-grow: 1;

    &.header {
        padding: ${p => p.theme.componentSmallInnerVerticalPadding}px 0;
    }
`;

export const SwitcherButton = styled(FloatingButtonSimple)`
    position: absolute;
    right: ${p => p.theme.pageMarginMedium}px;
    bottom: ${p => p.theme.pageMarginMedium}px;
    color: ${p => p.theme.baseColor};
`;

export const HeaderWrapper = styled.div`
    height: 30px;
    width: 100%;
    padding: 0 ${p => p.theme.pageMarginMedium}px;

    position: sticky;
    top: ${p => -p.theme.navBar.largeTitleHeight}px;

    background-color: ${p => p.theme.baseColor};

    display: flex;
    flex-direction: row;
    align-items: center;

    &.important {
        ::before {
            content: "";
            width: 8px;
            height: 8px;
            border-radius: 10px;
            background-color: ${p => p.theme.primaryAccentColor};
            margin-right: 8px;
        }
    }
`;

export const HeaderName = styled.div`
    ${p => p.theme.fontStyles.Tag5};
    color: ${p => p.theme.fgColorDark};

    border-radius: 12px;
`;

export const EventWrapper = styled.div<{ touched: boolean }>`
    height: 54px;
    width: 100%;

    padding: 0px ${p => p.theme.pageMarginMedium}px 4px;

    display: flex;
    flex-direction: column;

    font-size: 14px;

    &[role="button"] {
        cursor: pointer;
    }

    .app-cal-event-inner {
        border-left: 4px solid ${p => p.theme.primaryAccentColor};
        background-color: ${p => p.theme.primaryAccentColor}26;

        align-items: center;
        display: flex;
        flex-direction: row;

        flex-grow: 1;
    }

    &.past .app-cal-event-inner {
        border-left: 4px solid ${p => p.theme.calendar.pastEventAccent};
        background-color: ${p => p.theme.calendar.pastEventColor};
    }

    .app-cal-event-time {
        width: 70px;
        margin-right: 20px;

        color: ${p => p.theme.fgColorMedium};
        ${p => p.theme.fontStyles.Header5Fixed};

        height: ${p => p.theme.fontStyles.Header5Height}px;
        font-size: 11px;

        text-align: right;
    }

    .app-cal-event-text-area {
        align-self: flex-start;
        padding-top: 8px;

        color: ${p => p.theme.fgColorDark};
        ${p => p.theme.fontStyles.Body5};

        flex-grow: 1;
        flex-shrink: 1;

        margin-left: 8px;
        overflow: hidden;
    }

    .app-cal-event-name {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        font-weight: 500;
    }

    .app-cal-event-desc {
        color: ${p => p.theme.fgColorMedium};
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .app-cal-time-wrapper {
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
    }
`;
